export default __webpack_public_path__ + "static/media/screenshot_app_videos_purple.0936ae52.png";